import React from "react";
import AI from "../../assets/ai-powered.png";
import VR from "../../assets/vr-icon.png";
import Screen1 from "../../assets/screen1.png";
import Screen2 from "../../assets/screen2.png";
import BrandFeatureCard from "../cards/BrandFeatureCard";

const Aboutus = () => {
  return (
    <div className="bg-white px-4 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-[1728px] flex-col gap-8 py-8 text-black sm:gap-10 sm:py-10 lg:flex-row lg:gap-10 lg:py-12 xl:gap-12 xl:py-16 2xl:gap-[49px] 2xl:py-[110px]">
        <div className="w-full shrink-0 lg:max-w-[min(100%,535px)] lg:basis-[min(100%,535px)]">
          <h2 className="text-[26px] font-bold leading-tight sm:text-[32px] sm:leading-[38px]">
            About us
          </h2>
          <p className="mt-4 text-base font-normal leading-relaxed text-justify sm:mt-[26px] sm:text-lg sm:leading-7 lg:text-xl lg:leading-7">
            STEAM Minds is an innovative EdTech company that provides AI-powered
            personalized, interactive, simulative and adaptive gamified learning
            experiences. The company offers STEAM solutions for k12 through the
            use of advanced technology, including virtual, augmented, and mixed
            realities based web applications.
          </p>
          <h3 className="mt-6 text-[26px] font-normal leading-tight sm:mt-[26px] sm:text-[32px] sm:leading-[38px]">
            Brand Features
          </h3>
          <div className="mt-4 flex flex-col gap-3 min-[420px]:flex-row min-[420px]:flex-wrap min-[420px]:gap-x-8 min-[420px]:gap-y-3 lg:mt-0 lg:flex-col lg:gap-0">
            <div className="mt-0 flex items-center gap-3 lg:mt-6">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black sm:h-[43px] sm:w-[43px]">
                <img src={VR} className="h-6 w-6 sm:h-7 sm:w-7" alt="VR" />
              </div>
              <p className="text-base font-normal leading-5 sm:text-lg lg:text-xl">
                VR-Enabled Science Labs
              </p>
            </div>
            <div className="mt-0 flex items-center gap-3 lg:mt-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black sm:h-[43px] sm:w-[43px]">
                <img src={AI} className="h-6 w-6 sm:h-7 sm:w-7" alt="AI" />
              </div>
              <p className="text-base font-normal leading-5 sm:text-lg lg:text-xl">
                AI-Powered LMS
              </p>
            </div>
          </div>
        </div>

        <div className="grid min-w-0 flex-1 grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-x-5 sm:gap-y-5 lg:gap-x-7">
          <BrandFeatureCard
            title="VR-Enabled Science Labs"
            headingIcon={VR}
            cardImage={Screen1}
            subText="Immersive 3D simulations for science experiments. Safe, cost-effective alternative to physical labs with guided interactions. Aligned with international curricula and national SLOs. Accessible via VR headsets or standard devices."
            pClassName="mt-4 sm:mt-6 2xl:mt-9"
          />
          <BrandFeatureCard
            title="AI-Powered LMS"
            headingIcon={AI}
            cardImage={Screen2}
            subText="A personalized learning management system that adapts to each student's pace. Features an AI powered student portal for personalized tracking and management and Teachers' Portal with AI powered automated tools for Quiz drafting, checking and comprehensive teaching suite."
            pClassName="text-justify mt-4 sm:mt-6 2xl:mt-9"
          />
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
